// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  flex-wrap: wrap;
  padding: 1rem 1.25rem;
  margin-top: 2rem;
  border-top: 1px solid #ececec;
  color: #9a9aa0;
  font-size: 0.85rem;
}
.app-footer__brand {
  font-weight: 600;
  color: #bd8f6f;
}
.app-footer__sep {
  color: #d8d8dc;
}
.app-footer__copy {
  color: #9a9aa0;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/shared/layout/footer/footer.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,6BAAA;EACA,cAAA;EACA,kBAAA;AACF;AACE;EACE,gBAAA;EACA,cAAA;AACJ;AAEE;EACE,cAAA;AAAJ;AAGE;EACE,cAAA;AADJ","sourcesContent":[".app-footer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  flex-wrap: wrap;\n  padding: 1rem 1.25rem;\n  margin-top: 2rem;\n  border-top: 1px solid #ececec;\n  color: #9a9aa0;\n  font-size: 0.85rem;\n\n  &__brand {\n    font-weight: 600;\n    color: #bd8f6f; // brand primary\n  }\n\n  &__sep {\n    color: #d8d8dc;\n  }\n\n  &__copy {\n    color: #9a9aa0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
